import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Slide from './slide';
import Feed from './feed';
import Aside from './aside';
import Chip from 'Chip';

class Main extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { leftData, rightData } = this.props.content;
        const { slide, newsStreamRecommend, newsStream, viewMore, staticCenterData } = leftData;
        const feedData = {
            newsStreamRecommend,
            newsStream,
            viewMore,
            staticCenterData,
        };

        return (
            <div className={styles.main}>
               
                <div className={styles.mainLeft}>
                    <Chip id="289139" type="recommend" title="内蒙古頻道－焦点图（只出带图的文章）" groupName="main左侧数据" content={slide}>
                        <Slide />
                    </Chip>
                    <Feed content={feedData} />
                </div>
                <div className={styles.mainRight}>
                    <Aside content={rightData} />
                </div>
            </div>
        );
    }
}

export default Main;
